import { useAccount } from "wagmi";
import fetchLendOffersByBorrower from "../../services/fetchLendOffersByBorrower";
import { OfferType } from "./account/accountRows";
import { useDispatch } from "react-redux";
import { setModal } from "../../redux/counterSlice";
import AccountTable from "./account/accountTable";
import { getBalanceAlert } from "../balanceAlert";

const BorrowerOfferTab = () => {
  const dispatch = useDispatch();
  const { address } = useAccount();

  const action = (offer: OfferType, refresh?: () => void) => {
    const {
      amount,
      expiration,
      filledGlobalBids,
      isExpired,
      isGlobal,
      signingTime,
      status,
    } = offer;
    const isOfferActive = !(
      Number(signingTime) + Number(expiration) < Date.now() / 1000 &&
      !isExpired &&
      status === 0 &&
      (!isGlobal ? true : filledGlobalBids < Number(amount))
    );
    const { Element } = getBalanceAlert(offer);

    return (
      <>
        {isOfferActive && address !== offer.issuer && (
          <div className="flex flex-row justify-center items-center">
            {offer?.hasEnoughBalance && offer?.isApprovedEnough ? (
              <button
                onClick={() => {
                  if (!isOfferActive) return;
                  return dispatch(
                    setModal({
                      key: "LendingModal",
                      data: {
                        ...offer,
                        ...(refresh && { refresh }),
                        type: "accept",
                      },
                    })
                  );
                }}
                className={
                  "mx-1 p-2 bg-jacarta-500 shadow-jacarta-500 hover:bg-accent-dark text-center font-semibold text-white transition-all rounded-md"
                }
              >
                Accept
              </button>
            ) : (
              <Element />
            )}
            {!isGlobal && (
              <button
                onClick={() => {
                  if (!isOfferActive) return;
                  return dispatch(
                    setModal({
                      key: "RejectModal",
                      data: {
                        ...offer,
                        ...(refresh && { refresh }),
                      },
                    })
                  );
                }}
                className={
                  "mx-1 p-2 capitalize bg-jacarta-500 shadow-jacarta-500 hover:bg-red text-center font-semibold text-white transition-all rounded-md"
                }
              >
                Reject
              </button>
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <AccountTable
      fetcher={fetchLendOffersByBorrower}
      action={action}
      eventType={true}
      interestRate={true}
      checkBalance={true}
    />
  );
};

export default BorrowerOfferTab;
